import { labelServiceNew } from '../../helpers/services/productLabelNew.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
// import { SESSION } from "@/constants";
// import router from '@/router/index';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
}

export const PRODUCT_LABEL_MODULE_NEW = 'productLabelNew';

// ACTIONS
export const GET_ALL_PRODUCT_LABELS_NEW = 'getAllProductLabelsNew';
export const GET_PRODUCT_LABEL_NEW = 'getProductLabelNew';
export const CREATE_PRODUCT_LABEL_NEW = 'createProductLabelNew';
export const UPDATE_PRODUCT_LABEL_NEW = 'updateProductLabelNew';
export const UPDATE_PRODUCT_LABEL_STATUS_NEW = 'updateProductLabelStatusNew';

// MUTATIONS
const REQUESTING = "requesting";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const ALL_PRODUCT_LABELS_SUCCESS_NEW = "allProductLabelsSuccessNew";
const GET_PRODUCT_LABEL_SUCCESS_NEW = "getProductLabelSuccessNew";

export const actions = {
    [GET_ALL_PRODUCT_LABELS_NEW]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        labelServiceNew
            .getAllLabelsNew(filter)
            .then((result) => {
                commit(ALL_PRODUCT_LABELS_SUCCESS_NEW, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
    [GET_PRODUCT_LABEL_NEW]({commit}, {id}) {
        commit(REQUESTING, 'detail');
        return labelServiceNew
            .getLabelNew(id)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PRODUCT_LABEL_SUCCESS_NEW, result);
                return result;
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
    [CREATE_PRODUCT_LABEL_NEW]({commit}, {data, isCloseWhenSuccess=false}) {
        commit(REQUESTING, 'save');
        return labelServiceNew
            .createLabelNew(data)
            .then((result) => {
                var message = i18n.t('label.createX', [i18n.t('module.productLabel')]);
                sharedHelper.alertSuccessMessage(message);
                commit(SUCCESS);
                if (isCloseWhenSuccess == false) {
                    sharedHelper.alertSuccessMessage(message)
                }
                else {
                    sharedHelper.alertSuccessMessageAndClose(message)
                }
                return result;
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
    [UPDATE_PRODUCT_LABEL_NEW]({commit}, {data, isCloseWhenSuccess=false}) {
        commit(REQUESTING, 'save');
        return labelServiceNew
            .updateLabelNew(data)
            .then((result) => {
                var message = i18n.t('label.updateX', [i18n.t('module.productLabel')]);
                sharedHelper.alertSuccessMessage(message);
                commit(SUCCESS);
                if (isCloseWhenSuccess == false) {
                    sharedHelper.alertSuccessMessage(message)
                }
                else {
                    sharedHelper.alertSuccessMessageAndClose(message)
                }
                return result;
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
    [UPDATE_PRODUCT_LABEL_STATUS_NEW]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return labelServiceNew
            .updateLabelStatusNew(data)
            .then((result) => {
                var message = i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [i18n.t('module.productLabel')]);
                sharedHelper.alertSuccessMessage(message);
                commit(SUCCESS);
                dispatch(GET_ALL_PRODUCT_LABELS_NEW, {filter});
                return result;
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
};

export const mutations = {
    [ALL_PRODUCT_LABELS_SUCCESS_NEW](state, {data}) {
        let job = data.data || [];
        state.list.data = job;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);
        if(data.success) {
            state.list.data = job.map(item => (mapProductLabel(item)));
        }
    },
    [GET_PRODUCT_LABEL_SUCCESS_NEW](state, data) {
        let info = data.data;
        state.details = mapProductLabel(info);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};

function mapProductLabel(item) {
    return {
        id: item.uuid,
        date: item.date,
        dateFormat: filtersHelper.getDateFormat(item.date),
        isActive: item.is_active,
        createdBy: item.created_by,
        createdAt: filtersHelper.getDateFormat(item.created_at),
        updatedBy: item.updated_by,
        updatedAt: filtersHelper.getDateFormat(item.updated_at),
        product: item.product ? {
            value: item.product.uuid,
            text: item.product.name,
            id: item.product.uuid,
            name: item.product.name,
            lrmp: item.product.lrmp,
            referenceNumber: item.product.reference_number,
            dor: item.product.dor,
            expiredDate: item.product.expired_date ? filtersHelper.getDateFormat(item.product.expired_date) : null,
            endorseLabel: item.product.endorse_label,
            remark: item.product.remark,
            dossierSubmissionDate: item.product.dossier_submission_date ? filtersHelper.getDateFormat(item.product.dossier_submission_date) : null,
            approvalDate: item.product.approval_date ? filtersHelper.getDateFormat(item.product.approval_date) : null,
            isRegistrationCertificated: item.product.is_registration_certificated,
            shelfLifeProduction: item.product.shelf_life_production,
            shelfLifeTime: item.product.shelf_life_time,
            isActive: item.product.is_active,
            createdAt: filtersHelper.getDateFormat(item.product.created_at),
            createdBy: item.product.created_by,
            updatedAt: filtersHelper.getDateFormat(item.product.updated_at),
            updatedBy: item.product.updated_by,
        } : null,
        labels: item.labels ? item.labels.map(item => ({
            id: item.uuid,
            size: item.size,
            remark: item.remark,
            packagingMaterial: item.packaging_material,
            isActive: item.is_active,
            createdAt: filtersHelper.getDateFormat(item.created_at),
            createdBy: item.created_by,
            updatedAt: filtersHelper.getDateFormat(item.updated_at),
            updatedBy: item.updated_by,
            images: item.images ? item.images.map(item => ({
                id: item.uuid,
                imageUrl: item.image_url,
            })) : []
        })) : [],
    };
}